import {Outlet, redirect} from "react-router-dom";
import Header from "../../components/header/header";

const Home = () => {
    return(
        <>
            <Header/>
            <div className="margin-b-50"><Outlet/></div>
        </>
    )
}

export default Home;
